var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeCelsius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#363BC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15.2777L20 20M20 20L11.5 15.2777M20 20L20 29.5M29 24.0585V15.9414C29 15.5988 29 15.4275 28.9495 15.2747C28.9049 15.1395 28.8318 15.0154 28.7354 14.9107C28.6263 14.7924 28.4766 14.7092 28.177 14.5428L20.777 10.4317C20.4934 10.2741 20.3516 10.1953 20.2015 10.1645C20.0685 10.1371 19.9315 10.1371 19.7986 10.1645C19.6484 10.1953 19.5066 10.2741 19.223 10.4317L11.823 14.5428C11.5234 14.7092 11.3737 14.7924 11.2646 14.9107C11.1682 15.0154 11.0951 15.1395 11.0505 15.2747C11 15.4275 11 15.5988 11 15.9414V24.0585C11 24.4012 11 24.5725 11.0505 24.7253C11.0951 24.8605 11.1682 24.9846 11.2646 25.0893C11.3737 25.2076 11.5234 25.2908 11.823 25.4572L19.223 29.5683C19.5066 29.7259 19.6484 29.8046 19.7986 29.8355C19.9315 29.8629 20.0685 29.8629 20.2015 29.8355C20.3516 29.8046 20.4934 29.7259 20.777 29.5683L28.177 25.4572C28.4766 25.2908 28.6263 25.2076 28.7354 25.0893C28.8318 24.9846 28.9049 24.8605 28.9495 24.7253C29 24.5725 29 24.4012 29 24.0585Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCelsius);
export default __webpack_public_path__ + "static/media/HomeCelsius.ff3c26e592848bccad65360a999aa98d.svg";
export { ForwardRef as ReactComponent };